export default "__VITE_ASSET__DIodU8xo__"